import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chatData: {}, // Store user data
  isSocketConnected: false,
  conversationId: "",
};

const chatUserSlice = createSlice({
  name: "chatUser",
  initialState,
  reducers: {
    chatUserData: (state, action) => {
      state.chatData = action.payload;
    },
    isSocketConnected: (state, action) => {
      state.isSocketConnected = action.payload;
    },
    converId: (state, action) => {
      state.conversationId = action.payload;
    },
  },
});

export const { chatUserData, isSocketConnected, converId } =
  chatUserSlice.actions;
export default chatUserSlice.reducer;
